import { useEffect, useRef } from "react";
import LoginScreen from "../components/templates/auth/LoginPage";
import { useAuth } from "./AuthProvider";
import { useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, isSigningOut, signinRedirect } =
    useAuth();
  const location = useLocation();
  const signinStarted = useRef(false);
  const shouldSignIn = !isLoading && !isAuthenticated && !isSigningOut;

  useEffect(() => {
    if (!shouldSignIn || signinStarted.current) return;
    signinStarted.current = true;

    const from = location.pathname + location.search;
    localStorage.setItem("post_login_redirect", from);
    signinRedirect({ state: { from } });
  }, [shouldSignIn, location.pathname, location.search, signinRedirect]);

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return <>{children}</>;
}
